module.exports = __webpack_public_path__ + "static/img/function22.640eae0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/function22.gif
// module id = 8ovS
// module chunks = 0